const translate = {
  upload_photo: {
    en: 'Upload Photo',
    es: 'Subir Foto',
    fr: 'Télécharger une photo',
    de: 'Foto hochladen',
    pt: 'Carregar Foto',
    pl: 'Prześlij zdjęcie',
    nl: 'Foto uploaden',
    el: 'Ανέβασμα Φωτογραφίας',
    cs: 'Nahrát fotografii',
    sv: 'Ladda upp foto',
    hu: 'Fotó feltöltése',
    da: 'Upload foto',
    fi: 'Lataa kuva',
    sk: 'Nahrať fotografiu',
    bg: 'Качване на снимка',
    hr: 'Učitaj fotografiju',
    lt: 'Įkelti nuotrauką',
    lv: 'Augšupielādēt fotoattēlu',
    et: 'Laadi foto üles',
    sl: 'Naloži fotografijo',
    ga: 'Uaslódáil Grianghraf',
    mt: 'Itella ritratt',
    cy: 'Llwytho Llun',
    ro: 'Încărcați fotografia',
    it: 'Carica foto',
    zh_cn: '上传照片',
    hi: 'फ़ोटो अपलोड करें',
    ar: 'رفع الصورة',
    bn: 'ছবি আপলোড করুন',
    ru: 'Загрузить фото',
    ja: '写真をアップロード',
    tr: 'Fotoğraf Yükle',
    ko: '사진 업로드',
    vi: 'Tải ảnh lên',
    id: 'Unggah Foto',
    th: 'อัพโหลดรูปภาพ',
    ms: 'Muat Naik Foto',
    ar_eg: 'تحميل الصورة',
    uk: 'Завантажити фото',
  },
  upload_new_photo: {
    en: 'Upload New Photo',
    es: 'Subir Nueva Foto',
    fr: 'Télécharger une nouvelle photo',
    de: 'Neues Foto hochladen',
    pt: 'Carregar Nova Foto',
    pl: 'Prześlij nowe zdjęcie',
    nl: 'Nieuwe foto uploaden',
    el: 'Ανέβασμα Νέας Φωτογραφίας',
    cs: 'Nahrát novou fotografii',
    sv: 'Ladda upp nytt foto',
    hu: 'Új fotó feltöltése',
    da: 'Upload nyt foto',
    fi: 'Lataa uusi kuva',
    sk: 'Nahrať novú fotografiu',
    bg: 'Качване на нова снимка',
    hr: 'Učitaj novu fotografiju',
    lt: 'Įkelti naują nuotrauką',
    lv: 'Augšupielādēt jaunu fotoattēlu',
    et: 'Laadi uus foto üles',
    sl: 'Naloži novo fotografijo',
    ga: 'Uaslódáil Grianghraf Nua',
    mt: 'Itella ritratt ġdid',
    cy: 'Llwytho Llun Newydd',
    ro: 'Încărcați fotografia nouă',
    it: 'Carica nuova foto',
    zh_cn: '上传新照片',
    hi: 'नई फ़ोटो अपलोड करें',
    ar: 'رفع صورة جديدة',
    bn: 'নতুন ছবি আপলোড করুন',
    ru: 'Загрузить новое фото',
    ja: '新しい写真をアップロード',
    tr: 'Yeni Fotoğraf Yükle',
    ko: '새 사진 업로드',
    vi: 'Tải ảnh mới lên',
    id: 'Unggah Foto Baru',
    th: 'อัพโหลดรูปภาพใหม่',
    ms: 'Muat Naik Foto Baru',
    ar_eg: 'تحميل صورة جديدة',
    uk: 'Завантажити нове фото',
  },
  upload_image: {
    en: 'Upload Image',
    es: 'Subir Imagen',
    fr: 'Télécharger une image',
    de: 'Bild hochladen',
    pt: 'Carregar Imagem',
    pl: 'Prześlij obraz',
    nl: 'Afbeelding uploaden',
    el: 'Ανέβασμα Εικόνας',
    cs: 'Nahrát obrázek',
    sv: 'Ladda upp bild',
    hu: 'Kép feltöltése',
    da: 'Upload billede',
    fi: 'Lataa kuva',
    sk: 'Nahrať obrázok',
    bg: 'Качване на изображение',
    hr: 'Učitaj sliku',
    lt: 'Įkelti vaizdą',
    lv: 'Augšupielādēt attēlu',
    et: 'Laadi pilt üles',
    sl: 'Naloži sliko',
    ga: 'Uaslódáil Íomhá',
    mt: 'Itella immaġni',
    cy: 'Llwytho Delwedd',
    ro: 'Încărcați imaginea',
    it: 'Carica immagine',
    zh_cn: '上传图片',
    hi: 'छवि अपलोड करें',
    ar: 'رفع الصورة',
    bn: 'ছবি আপলোড করুন',
    ru: 'Загрузить изображение',
    ja: '画像をアップロード',
    tr: 'Resim Yükle',
    ko: '이미지 업로드',
    vi: 'Tải hình ảnh lên',
    id: 'Unggah Gambar',
    th: 'อัพโหลดภาพ',
    ms: 'Muat Naik Imej',
    ar_eg: 'تحميل صورة',
    uk: 'Завантажити зображення',
  },
  upload_more_images: {
    en: 'Upload More Images',
    es: 'Subir Más Imágenes',
    fr: "Télécharger Plus d'Images",
    de: 'Mehr Bilder hochladen',
    pt: 'Carregar Mais Imagens',
    pl: 'Prześlij więcej obrazów',
    nl: 'Meer afbeeldingen uploaden',
    el: 'Ανέβασμα Περισσότερων Εικόνων',
    cs: 'Nahrát více obrázků',
    sv: 'Ladda upp fler bilder',
    hu: 'Tölts fel több képet',
    da: 'Upload flere billeder',
    fi: 'Lataa lisää kuvia',
    sk: 'Nahrať viac obrázkov',
    bg: 'Качване на още изображения',
    hr: 'Učitaj više slika',
    lt: 'Įkelti daugiau vaizdų',
    lv: 'Augšupielādēt vairāk attēlu',
    et: 'Laadi rohkem pilte üles',
    sl: 'Naloži več slik',
    ga: 'Uaslódáil Tuilleadh Íomhánna',
    mt: 'Itella Aktar Stampi',
    cy: 'Llwytho Mwy o Ddelweddau',
    ro: 'Încărcați mai multe imagini',
    it: 'Carica più immagini',
    zh_cn: '上传更多图片',
    hi: 'और छवियां अपलोड करें',
    ar: 'رفع المزيد من الصور',
    bn: 'আরও ছবি আপলোড করুন',
    ru: 'Загрузить больше изображений',
    ja: 'さらに画像をアップロード',
    tr: 'Daha Fazla Resim Yükle',
    ko: '더 많은 이미지 업로드',
    vi: 'Tải thêm hình ảnh lên',
    id: 'Unggah Lebih Banyak Gambar',
    th: 'อัพโหลดรูปภาพเพิ่มเติม',
    ms: 'Muat Naik Lebih Banyak Imej',
    ar_eg: 'تحميل المزيد من الصور',
    uk: 'Завантажити більше зображень',
  },
  image_hint: {
    en: 'Upload JPG image, Max size of 800K',
    es: 'Subir imagen JPG, tamaño máximo de 800K',
    fr: 'Télécharger une image JPG, taille maximale de 800K',
    de: 'JPG-Bild hochladen, maximale Größe 800K',
    pt: 'Carregar imagem JPG, tamanho máximo de 800K',
    pl: 'Prześlij obraz JPG, maksymalny rozmiar 800K',
    nl: 'Upload JPG-afbeelding, maximale grootte van 800K',
    el: 'Ανέβασμα εικόνας JPG, μέγιστο μέγεθος 800K',
    cs: 'Nahrajte obrázek JPG, maximální velikost 800K',
    sv: 'Ladda upp JPG-bild, maxstorlek 800K',
    hu: 'JPG kép feltöltése, max méret 800K',
    da: 'Upload JPG-billede, maks. størrelse 800K',
    fi: 'Lataa JPG-kuva, enimmäiskoko 800K',
    sk: 'Nahrajte obrázok JPG, maximálna veľkosť 800K',
    bg: 'Качване на JPG изображение, максимален размер 800K',
    hr: 'Učitajte JPG sliku, maksimalna veličina 800K',
    lt: 'Įkelkite JPG vaizdą, didžiausias dydis 800K',
    lv: 'Augšupielādēt JPG attēlu, maksimālais izmērs 800K',
    et: 'Laadi üles JPG-pilt, maksimaalne suurus 800K',
    sl: 'Naložite JPG sliko, največja velikost 800K',
    ga: 'Uaslódáil íomhá JPG, an méid uasta 800K',
    mt: "Itella immaġni JPG, daqs massimu ta' 800K",
    cy: 'Llwytho delwedd JPG, maint uchaf o 800K',
    ro: 'Încărcați imaginea JPG, dimensiunea maximă de 800K',
    it: 'Carica immagine JPG, dimensione massima di 800K',
    zh_cn: '上传 JPG 图片，最大大小为 800K',
    hi: 'JPG छवि अपलोड करें, अधिकतम आकार 800K',
    ar: 'رفع صورة JPG، الحجم الأقصى 800K',
    bn: 'JPG ইমেজ আপলোড করুন, সর্বাধিক আকার 800K',
    ru: 'Загрузить изображение JPG, максимальный размер 800K',
    ja: 'JPG画像をアップロード、最大サイズ800K',
    tr: 'JPG resim yükle, maksimum boyut 800K',
    ko: 'JPG 이미지 업로드, 최대 크기 800K',
    vi: 'Tải ảnh JPG lên, kích thước tối đa 800K',
    id: 'Unggah gambar JPG, ukuran maksimum 800K',
    th: 'อัพโหลดภาพ JPG ขนาดสูงสุด 800K',
    ms: 'Muat Naik Imej JPG, Saiz Maksimum 800K',
    ar_eg: 'تحميل صورة JPG، الحد الأقصى للحجم 800K',
    uk: 'Завантажте зображення JPG, максимальний розмір 800K',
  },
  error_message: {
    en: 'Invalid Image Format or Size!\n Please upload in JPG format and under size limit 800K',
    es: '¡Formato o tamaño de imagen no válido!\n Por favor, suba en formato JPG y bajo el límite de tamaño de 800K',
    fr: "Format ou taille d'image invalide !\n Veuillez télécharger au format JPG et sous la limite de taille de 800K",
    de: 'Ungültiges Bildformat oder -größe!\n Bitte laden Sie im JPG-Format und unter der Größenbegrenzung von 800K hoch',
    pt: 'Formato ou tamanho de imagem inválido!\n Por favor, carregue no formato JPG e abaixo do limite de tamanho de 800K',
    pl: 'Nieprawidłowy format lub rozmiar obrazu!\n Prześlij w formacie JPG i poniżej limitu rozmiaru 800K',
    nl: 'Ongeldig afbeeldingsformaat of -grootte!\n Upload in JPG-formaat en onder de grootte limiet van 800K',
    el: 'Μη έγκυρη μορφή ή μέγεθος εικόνας!\n Παρακαλώ ανεβάστε σε μορφή JPG και κάτω από το όριο μεγέθους των 800K',
    cs: 'Neplatný formát nebo velikost obrázku!\n Nahrajte ve formátu JPG a pod limit velikosti 800K',
    sv: 'Ogiltigt bildformat eller storlek!\n Ladda upp i JPG-format och under storleksgränsen 800K',
    hu: 'Érvénytelen képformátum vagy méret!\n Töltse fel JPG formátumban és a méretkorlát alatt 800K',
    da: 'Ugyldigt billedformat eller størrelse!\n Upload venligst i JPG-format og under størrelsesgrænsen 800K',
    fi: 'Virheellinen kuvan muoto tai koko!\n Lataa JPG-muodossa ja kokorajoituksen alle 800K',
    sk: 'Neplatný formát alebo veľkosť obrázka!\n Nahrajte vo formáte JPG a pod limitom veľkosti 800K',
    bg: 'Невалиден формат или размер на изображението!\n Моля, качете в JPG формат и под ограничението за размер от 800K',
    hr: 'Nevažeći format ili veličina slike!\n Učitajte u JPG formatu i ispod ograničenja veličine od 800K',
    lt: 'Neteisingas vaizdo formatas arba dydis!\n Įkelkite JPG formatu ir neviršykite 800K dydžio limito',
    lv: 'Nederīgs attēla formāts vai izmērs!\n Lūdzu, augšupielādējiet JPG formātā un zem izmēra ierobežojuma 800K',
    et: 'Vigane pildi formaat või suurus!\n Laadige üles JPG-vormingus ja suuruspiirangu alla 800K',
    sl: 'Neveljaven format ali velikost slike!\n Naložite v JPG formatu in pod velikostno mejo 800K',
    ga: 'Formáid Íomhá nó Méid Neamhbhailí!\n Uaslódáil i bhformáid JPG agus faoi theorainn mhéid 800K',
    mt: "Format jew daqs tal-immaġni mhux validu!\n Itella f'format JPG u taħt il-limitu tad-daqs 800K",
    cy: 'Fformat Delwedd neu Faint Annilys!\n Llwythwch mewn fformat JPG ac o dan derfyn maint o 800K',
    ro: 'Format sau dimensiune imagine nevalidă!\n Vă rugăm să încărcați în format JPG și sub limita de dimensiune de 800K',
    it: "Formato o dimensione dell'immagine non valida!\n Carica in formato JPG e sotto il limite di dimensione di 800K",
    zh_cn: '无效的图像格式或大小！\n 请上传 JPG 格式，大小不超过 800K',
    hi: 'अमान्य छवि प्रारूप या आकार!\n कृपया JPG प्रारूप में अपलोड करें और आकार सीमा 800K से कम रखें',
    ar: 'تنسيق الصورة أو الحجم غير صالح!\n يرجى التحميل بتنسيق JPG وتحت الحد الأقصى للحجم 800K',
    bn: 'অবৈধ চিত্র বিন্যাস বা আকার!\n দয়া করে JPG বিন্যাসে এবং 800K আকারের সীমার মধ্যে আপলোড করুন',
    ru: 'Недопустимый формат или размер изображения!\n Пожалуйста, загрузите в формате JPG и размером не более 800K',
    ja: '無効な画像フォーマットまたはサイズです！\n JPG形式でアップロードし、サイズ制限800K以下にしてください',
    tr: 'Geçersiz Görüntü Formatı veya Boyutu!\n Lütfen JPG formatında ve 800K boyut sınırının altında yükleyin',
    ko: '유효하지 않은 이미지 형식 또는 크기입니다!\n JPG 형식으로 업로드하고 크기 제한 800K 이하로 업로드하세요',
    vi: 'Định dạng hoặc kích thước hình ảnh không hợp lệ!\n Vui lòng tải lên định dạng JPG và dưới giới hạn kích thước 800K',
    id: 'Format atau ukuran gambar tidak valid!\n Unggah dalam format JPG dan di bawah batas ukuran 800K',
    th: 'รูปแบบหรือขนาดภาพไม่ถูกต้อง!\n โปรดอัพโหลดในรูปแบบ JPG และขนาดไม่เกิน 800K',
    ms: 'Format atau saiz imej tidak sah!\n Sila muat naik dalam format JPG dan di bawah had saiz 800K',
    ar_eg: 'تنسيق الصورة أو الحجم غير صالح!\n يرجى التحميل بتنسيق JPG وتحت الحد الأقصى للحجم 800K',
    uk: 'Недійсний формат або розмір зображення!\n Завантажте у форматі JPG та менше за ліміт розміру 800K',
  },
}
export default translate
